
$models.sync = {
	
	getConnectionDetails : function($params, $callbackSuccess, $callbackFailure) {
		$models.all.getDataFromAPI('connect.json', $params, $callbackSuccess, $callbackFailure, 'POST');
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/sync.js